import React from 'react';
import './MonthList.scss';
import { getMonthsPeriod } from '../../../../helpers/datetime';

const MonthList = ({ period, onSelectMonth, selectedMonth }) => {
    const months = period || [];

    return (
        <div className="month-list">
            {months.length > 0 &&
                months.map((month, index) => (
                    <div
                        className={`month-list__item${month === selectedMonth ? ' selected' : ''}`}
                        key={index}
                        onClick={() => onSelectMonth(month)}
                        style={{ cursor: 'pointer' }}
                    >
                        {month}
                    </div>
                ))}
        </div>
    );
};

export default MonthList;
